
import { defineComponent, inject, ref, computed, provide } from "vue"
import axios from "axios";
//icons
import { Search, ArrowLeft } from '@element-plus/icons-vue'
import { ElNotification } from 'element-plus'
import type { TableInstance } from 'element-plus'
//components
import MixedWidget1 from "@/components/widgets/mixed/Widget1.vue";
import MixedWidget14 from "@/components/widgets/mixed/Widget14.vue";
import DialogAcrd from "@/components/modals/general/ModalAcrd.vue"
import ModalObservaciones from "@/views/tournaments/Modals/ModalObservaciones.vue";
//services
import eventService from "@/core/services/EventService";
import AcrdService from '@/core/services/AcrdService';
import repService from "@/core/services/RepmanService"
import { errManager, mbtoa, showNotification } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";
import moment from 'moment';
moment.locale("es");

export default defineComponent({
    props: {
        evento: {
            type: Object,
            required: true,
            default: {}
        },
        sport: {
            type: Object,
            required: true,
            default: {}
        },
        rowClub: {
            type: Object,
            required: true,
            default: {}
        },
        checkdoc: {
            type: Array,
            required: true,
            default: []
        },
        listStatus: {
            type: null,
            required: true,
            default: []
        }
    },
    components: {
        MixedWidget1, MixedWidget14, DialogAcrd, ModalObservaciones
    },
    setup(props) {
        let fURL;
        const { t } = useI18n();
        const indexRow = ref(0)
        const singleTableRef = ref<TableInstance>()
        const altura = screen.height - 350;
        const repo = ref(process.env.VUE_APP_REPO)
        const action = ref(0)
        const dialogNominal = inject<boolean>('dialogNominal')
        const listRTRegister = ref<any>([])
        const listRCheckDoc = ref<any>([])
        const listRGender = ref<any>([])
        const listNominal = ref<any>([])
        const total = ref(0)
        const loaderGral = ref(false)
        const loaderSumary = ref<any>(false)
        const loaderTable = ref(false)
        const loaderDownload = ref(false)
        const fechaFin = ref<Date | null>(null)
        const multipleSelection = ref<any[]>([])

        const searchText = ref("")
        const tregister = ref("D")
        const listChecks = ref<any>([])
        const gblDialogAcrd = ref<any>(false) //modal register
        const gblDialogTest = ref<any>(false)
        const listSetting = ref<any>({}) //lista de configuraciones
        const closure = ref<any>({})
        const repman = ref<any>({})
        //get data sharing
        const gblDialog = inject<any>('gblDialog')
        const gblRowAcrd = inject<any>('gblRowAcrd')
        const dialogObservation = ref(false)
        const rowIdObs = ref<any>('')
        //const idcheckdoc = ref<any>([])
        const rowAcrd = ref<any>({})
        const rowSelected = ref<any>({});
        //credentiasl
        const dialogCredentials = ref(false);
        const optionCredential = ref(true)
        const loadingCredential = ref(false);

        provide('gblDialogAcrd', gblDialogAcrd)
        provide('gblDialogTest', gblDialogTest)
        provide('rowAcrd', rowAcrd)
        provide('dialogObservation', dialogObservation)
        provide('rowIdObs', rowIdObs)

        //OBSERVSSDJF SDKJFKDF SKJDHKS  POR REVISAR
        const dialogAcrd = ref(false)
        provide('dialogAcrd', dialogAcrd)

        //methods
        const onOpened = () => {
            setStatus()
            getSetting()
            getRepman()
        }

        const getSetting = async () => {
            loaderGral.value = true
            await AcrdService.options('setting', { idevent: props.evento.idevent, idsport: props.sport.idsport })
                .then((res) => {
                    loaderGral.value = false
                    listSetting.value = res.data
                    closure.value = res.data.closure
                    fechaFin.value = closure.value.date_end
                    tregister.value = res.data.tregister[0]?.id
                    getSummary()
                    getListNominal()
                }).catch(({ response }) => {
                    loaderGral.value = false
                    errManager(response)
                })
        }

        const setStatus = () => {
            if (listChecks.value.length == 0) {
                listChecks.value.length = 0
                props.listStatus.forEach((element: any) => {
                    listChecks.value.push(element.id)
                });
            }
        }

        const onClosed = () => {
            total.value = 0
            listNominal.value = []
            listRCheckDoc.value = []
            listRGender.value = []
            listRTRegister.value = []
            listSetting.value = {}
            closure.value = {}
            loaderGral.value = false
        }

        //resumen
        const getSummary = async () => {
            loaderSumary.value = true
            listRTRegister.value = []
            listRCheckDoc.value = []
            listRGender.value = []
            total.value = 0
            listRGender.value.slice(0)
            await eventService.summary({
                idevent: props.evento?.idevent,
                idsport: props.sport.idsport,
                checkdoc: listChecks.value,
                iduni: props.rowClub.idinstitution
            })
                .then((res) => {
                    listRTRegister.value = res.data.rtregister
                    listRCheckDoc.value = res.data.rcheckdoc
                    listRGender.value = res.data.rgender
                    listRGender.value.forEach(element => {
                        total.value += parseInt(element.quantity)
                    });
                    loaderSumary.value = false
                }).catch(({ response }) => {
                    loaderSumary.value = false
                    errManager(response)
                })
        }

        const getListNominal = async () => {
            listNominal.value.length = 0
            loaderTable.value = true
            await eventService.getNominal({
                idevent: props.evento.idevent,
                idsport: props.sport.idsport,
                iduni: props.rowClub.idinstitution,
                checkdoc: listChecks.value,
                type_register: tregister.value,
            })
                .then((res) => {
                    listNominal.value = res.data
                    loaderTable.value = false

                    const row = listNominal.value[indexRow.value]
                    if (row) {
                        singleTableRef.value?.setCurrentRow(row)
                    }

                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })
        }

        //filters
        const filteredNominal = computed(() => {
            return listNominal.value.filter(
                (item) =>
                    item.persona.toLowerCase().includes(searchText.value.toLowerCase()) ||
                    item.docnumber.includes(searchText.value.toLowerCase())
            );
        });

        /*
        const getSelectRow = (data) => {
            Object.assign(rowAcrd.value, data, { tregister: tregister }, { idevent: props.evento.idevent }, { idsport: props.sport.idsport })
            action.value = 1
            gblDialogAcrd.value = true
        }
        */

        const OnTest = async (row) => {
            loaderTable.value = true
            await AcrdService.getAcreditation(row.idacreditation, 'show')
                .then((res) => {
                    loaderTable.value = false
                    Object.assign(rowAcrd.value, res.data.info)
                    gblDialogTest.value = true
                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })
        }

        const onEdit = async (row, accion, index) => {
            indexRow.value = index;
            rowSelected.value = row
            loaderTable.value = true
            await AcrdService.getAcreditation(row.idacreditation, 'show')
                .then((res) => {
                    loaderTable.value = false
                    Object.assign(rowAcrd.value, res.data.info)
                    action.value = accion
                    gblDialogAcrd.value = true
                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })

            //Object.assign(row)
            //action.value = accion
            //gblDialogAcrd.value = true
        }

        const onDelete = (row) => {
            Swal.fire({
                title: t('deleteRecord'),
                html: `¿Desea eliminar al participante <b>${row.firstname} ${row.lastname}</b> de la lista nominal?`,
                icon: 'question',
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                },
                showCancelButton: true,
                confirmButtonText: t('delete'),
                cancelButtonText: t('cancel'),
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return AcrdService.delete(row.idacreditation)
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        icon: result.value.status,
                        title: result.value.title,
                        html: result.value.message
                    })
                    if (result.value.status === 'success') {
                        getListNominal()
                        getSummary()
                    }
                    //result.value.status === 'success' && 
                }
            })
        }

        //Descargar reportes Excel
        const DownloadXLSXPDF = (ext, target, payload) => {
            loaderDownload.value = true
            let params = new URLSearchParams(payload);
            axios({
                url: process.env.VUE_APP_API_URL + `/${ext}/${target}?${params}`,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                if (ext == 'zip')
                    var fileBlob = new Blob([response.data], { type: 'application/zip' });
                else
                    var fileBlob = new Blob([response.data]);

                //var nameFile = moment().format() + "." + ext;
                var contentDisposition = response.headers['content-disposition'];
                var match = /filename="([^"]*)"/.exec(contentDisposition);
                var nameFile = match && match[1] ? match[1] : moment().format() + "." + ext;

                if (!fURL) {
                    fURL = document.createElement('a');
                    fURL.style.display = 'none';
                    document.body.appendChild(fURL);
                }
                var fileURL = window.URL.createObjectURL(fileBlob);
                fURL.href = fileURL;
                fURL.setAttribute('download', nameFile);
                fURL.click();
            }).catch((err) => {
                loaderDownload.value = false
                errManager(err)
            }).finally(() => {
                loaderDownload.value = false;
            });
        }

        const handleSelectionChange = (val: any[]) => {
            multipleSelection.value = val
            /*
            multipleSelection.value = []
            val.forEach(item => {
                if (item.hasOwnProperty('checkdoc') && (item.checkdoc == '0' || item.checkdoc == '4')) {
                    multipleSelection.value.push(item);
                }
            });
            */
        }

        const onObservations = (data) => {
            rowIdObs.value = data.idacreditation
            dialogObservation.value = true
        }

        const getRepman = async () => {
            repman.value = {}
            await repService.getData({
                idclub: props.rowClub.idinstitution,
                status: 1
            }).then((res) => {
                repman.value = res.data
            }).catch(({ response }) => {
                errManager(response)
            })
        }

        const changeCheckDoc = () => {
            getListNominal()
            getSummary()
        }

        const generateCredentials = () => {

            let miMultipleSelection = <any>[];
            multipleSelection.value.forEach(item => {
                if (item.hasOwnProperty('checkdoc') && (item.checkdoc == '1')) {
                    miMultipleSelection.push(item.idacreditation);
                }
            });

            if (miMultipleSelection.length > 0) {
                DownloadXLSXPDF('pdf', 'credentials', {
                    a: mbtoa(props.evento.idevent),
                    b: mbtoa(props.sport.idsport),
                    c: mbtoa(props.rowClub.idinstitution),
                    d: miMultipleSelection
                })
            } else {
                ElNotification({
                    title: process.env.VUE_APP_NAME,
                    message: 'No se encontrarón registros para generar credenciales',
                    type: 'error',
                })
            }
        }

        const onDialogAcrd = (row) => {
            gblRowAcrd.value = row
            gblDialogAcrd.value = true
        };

        const activeCredential = () => {
            dialogCredentials.value = true
        };

        const sendActiveCredentials = async() => {

            let miMultipleSelection = <any>[];
            multipleSelection.value.forEach(item => {
                if (item.hasOwnProperty('checkdoc') && (item.checkdoc == '1')) {
                    miMultipleSelection.push(item.idacreditation);
                }
            });

            if(miMultipleSelection.length>0){
                loadingCredential.value = true;
                AcrdService.options('actived', {ids: miMultipleSelection, option: optionCredential.value})
                .then((res)=>{
                    loadingCredential.value = false;
                    if(res.data.status == 'success'){
                        dialogCredentials.value = false;
                        getListNominal();
                    }
                    showNotification(res.data)

                }).catch(({response})=>{
                    loadingCredential.value = false;
                    errManager(response);
                });
            }
        } 

        return {
            t,
            mbtoa,
            fechaFin,
            altura,
            action,
            dialogNominal,
            singleTableRef,
            rowSelected,

            //more
            gblRowAcrd,
            searchText,
            tregister,
            listChecks,
            closure,
            //loaders
            repo, loaderSumary, loaderTable, loaderGral, loaderDownload,
            //icons,
            Search, ArrowLeft,
            //list
            listRTRegister,
            listRCheckDoc,
            listRGender,
            listNominal,
            listSetting,
            total,
            multipleSelection,
            rowIdObs,
            repman,
            dialogCredentials,
            optionCredential,
            loadingCredential,

            //methods
            onOpened,
            getSetting,
            onClosed,
            getListNominal,
            filteredNominal,
            //getSelectRow,
            onDialogAcrd,
            getRepman,
            onEdit,
            onDelete,
            DownloadXLSXPDF,
            handleSelectionChange,
            onObservations,
            OnTest,
            generateCredentials,
            activeCredential,
            sendActiveCredentials
        }
    },
})
